export const stringsKey = "AddVariableButton";
export const englishStrings = {
	cancelText: "Cancel",
	addDialogTitle: "Add Variable",
	addDialogName: "Name",
	addDialogValue: "Value",
	addDialogGroup: "Group",
	addDialogConfirm: "Add",
	addVariableTooltip: "Add Variable",
};
